export function getBooleanValue(value?: string): boolean {
  try {
    return JSON.parse(value!) as boolean;
  } catch (e) {
    return false;
  }
}
